import React from 'react';
import styles from './GuaranteesForSeller.module.scss';
import Guarantees from '../guarantees';
import GuaranteePoints from '../guarantees/components/guaranteePoints/GuaranteePoints';
import PaymentOptions from '../guarantees/components/paymentOptions/PaymentOptions';
import SellerPoints from './components/sellerPoints';

interface IGuaranteesProps {
  aboveComponents?: any;
}

const GuaranteesForSeller = (props: IGuaranteesProps) => (
  <Guarantees
    {...props}
    guranteePoints={<GuaranteePoints/>}
    paymentOptions={<PaymentOptions className={styles.paymentOptions}/>}
    howItWorksPoints={<SellerPoints/>}
  />
);

GuaranteesForSeller.defaultProps = {};

export default React.memo(GuaranteesForSeller);
